import { StationTechnicalModeEnum } from '../model/StationTechnicalModeEnum';

export const createStationTechnicalModeTitle = (mode: StationTechnicalModeEnum): string => {
    switch (mode) {
        case StationTechnicalModeEnum.OFF:
            return 'Off';
        case StationTechnicalModeEnum.ON:
            return 'On';
    }
};
